import { Button } from '../../components/button'
import { DashboardWrapper } from "../../container/dashboardWrapper"
import { StyledContainer, StyledContent, StyledMainContentWrapper, StyledTopWrapper, StyledNextPageDiv, StyledNextPageDivContainer, StyledContentGrid, AboutInstructorSection, AboutInstructorContentWrapper, AboutInstructorContent, AboutInstructorExtraInfo, StyledAccordion, StyledAccordionSummary } from "../../styles/subjects"

import {
    MdAssessment,
    MdTimer
} from "react-icons/md";
import { QuestionsStepper } from '../../components/questions-stepper'
import { subjectInfo } from '../../services/subjectData'
import { Link } from 'react-router-dom';
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb';
import { Avatar } from '@material-ui/core';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { SubjectVideos } from '../../components/subjects/subject-videos/subject-videos';
const ViewSubject = () => {
    return (
        <DashboardWrapper>
            <StyledTopWrapper>
                <StyledContainer>
                    <StyledContent>
                        <Breadcrumb
                            crumbs={['subjects', 'Mathematics']}
                        />
                        <div className="top">
                            <h1 className="subject-title">Mathematics</h1>
                        </div>
                        <div className="bottom">
                            <p className='exam-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat. Augue mauris augue neque gravida in. Quam viverra orci sagittis eu volutpat odio facilisis mauris.</p>
                        </div>
                        <div className="download-result-btn" style={{ marginTop: '3rem' }}>
                            <Link to="/student/examination/start">
                                <Button variant="secondary">Begin course</Button>
                            </Link>
                        </div>
                    </StyledContent>
                </StyledContainer>
            </StyledTopWrapper>
            <StyledNextPageDiv>
                <StyledNextPageDivContainer>
                    <div className="subject-instructor-info-div">
                        <div>
                            <Avatar alt="Name" src="/assets/images/avatar.jpg" sx={{ width: 32, height: 32 }} />
                        </div>
                        <div>
                            <h2 className='subject-instructor-info-name'>Bello Ade</h2>
                            <h3 className='subject-instructor-info-position'>Instructor</h3>
                        </div>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdTimer />
                        </div>
                        <span>1 Term</span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdAssessment />
                        </div>
                        <span>JSS 1</span>
                    </div>
                </StyledNextPageDivContainer>
            </StyledNextPageDiv>
            <StyledMainContentWrapper>
                <StyledContainer>
                    <StyledContentGrid>
                        <QuestionsStepper subjectInfo={subjectInfo} />
                        <div>
                            {/* <h1>Table of Contents</h1> */}
                            <StyledAccordion>
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <p className='styled-summary-title'>Table of Contents </p>
                                    <div className='horizontal-line' />
                                </StyledAccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>Whole Numbers</li>
                                        <li>Basic Operations on Whole Numbers: Substraction and Addition</li>
                                        <li>Counting in Base Two</li>
                                    </ul>
                                </AccordionDetails>
                            </StyledAccordion>
                            <StyledAccordion>
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <p className='styled-summary-title'>VIDEOS </p>
                                    <div className='horizontal-line' />
                                </StyledAccordionSummary>
                                <AccordionDetails>
                                    <SubjectVideos />
                                </AccordionDetails>
                            </StyledAccordion>
                            <StyledAccordion>
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <p className='styled-summary-title'>MATERIALS </p>
                                    <div className='horizontal-line' />
                                </StyledAccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                        malesuada lacus ex, sit amet blandit leo lobortis eget.
                                    </p>
                                </AccordionDetails>
                            </StyledAccordion>
                            <StyledAccordion>
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <p className='styled-summary-title'>DOWNLOADED CONTENT </p>
                                    <div className='horizontal-line' />
                                </StyledAccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                        malesuada lacus ex, sit amet blandit leo lobortis eget.
                                    </p>
                                </AccordionDetails>
                            </StyledAccordion>

                        </div>
                    </StyledContentGrid>
                </StyledContainer>
                <AboutInstructorSection>
                    <StyledContainer>
                        <AboutInstructorContentWrapper>
                            <AboutInstructorContent>
                                <h1 className='heading-text'>About your Instructor</h1>
                                <p className='main-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat.</p>
                            </AboutInstructorContent>
                            <AboutInstructorExtraInfo>
                                <div>
                                    <Avatar alt="Name" src="/assets/images/avatar.jpg" sx={{ width: 58, height: 58 }} />
                                </div>
                                <div>
                                    <h2 className='instructor-extra-info-name'>Bello Ade</h2>
                                    <h3 className='instructor-extra-info-position'>Instructor</h3>
                                </div>
                            </AboutInstructorExtraInfo>
                        </AboutInstructorContentWrapper>
                    </StyledContainer>
                </AboutInstructorSection>
            </StyledMainContentWrapper>

        </DashboardWrapper >
    )
}

export default ViewSubject
